import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { PaymentTaskOrderAllocatedExpenseEditForm } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskOrderAllocatedExpenseEditForm';

export const PaymentTaskOrderAllocatedExpenses = () => {
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle(`プロジェクト別按分金額の投入`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        {
          label: `プロジェクト（費用） - ${_t_!.name}`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders`,
        },
        {
          label: `プロジェクト（費用）詳細`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}`,
        },
        {
          label: `支払タスク詳細`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}/payment_tasks/${task!.id}`,
        },
      ]),
    []
  );

  const { _po_, mePurchaseOrderMember } = useCurrentPurchaseOrder();
  const { paymentTask: task } = useCurrentPaymentTask();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <PaymentTaskOrderAllocatedExpenseEditForm />
    </WorkspaceLayout>
  );
};
